import React, { useEffect } from 'react';

interface ToastProps {
    open: boolean;
    message: string;
    severity: 'success' | 'error' | 'info' | 'warning';
    handleClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ open, message, severity, handleClose }) => {

    useEffect(() => {
        if (open) {
            const timer = setTimeout(() => {
                handleClose();
            }, 6000);
            return () => clearTimeout(timer);
        }
    }, [open, handleClose]);

    if (!open) return null;

    const getBackgroundColor = () => {
        switch (severity) {
            case 'success': return '#4caf50';
            case 'error': return '#f44336';
            case 'info': return '#2196f3';
            case 'warning': return '#ff9800';
            default: return '#333';
        }
    };

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 9999,
            minWidth: '250px',
            maxWidth: '350px',
            backgroundColor: getBackgroundColor(),
            color: '#fff',
            padding: '12px 20px',
            borderRadius: '6px',
            boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontFamily: 'inherit',
            transition: 'all 0.3s ease',
            animation: 'toast-slide-in 0.3s ease-out forwards'
        }}>
            <style>
                {`
                @keyframes toast-slide-in {
                    0% { transform: translateX(100%); opacity: 0; }
                    100% { transform: translateX(0); opacity: 1; }
                }
                `}
            </style>

            <div style={{ fontSize: '14px', fontWeight: 500, marginRight: '15px' }}>
                {message}
            </div>

            <button
                onClick={handleClose}
                style={{
                    background: 'transparent',
                    border: 'none',
                    color: '#fff',
                    fontSize: '22px',
                    cursor: 'pointer',
                    padding: '0',

                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: 0.8
                }}
            >
                &times;
            </button>
        </div>
    );
};

export default Toast;